import request from '@/utils/request'
import Setting from '../settings'
import jq from 'jquery'
import { getToken,getStroage } from '@/utils/auth.js'
const {
  apiDomain
} = Setting


// 获取权限列表
export async function permissionsList(params) {
  return request({
    url: apiDomain + '/base/admin/permission/filterTree',
    method: 'get',
    params
  })
}
// 角色授权权限列表
export async function rolePermissionsList(params) {
  return request({
    url: apiDomain + '/base/admin/permission/tree',
    method: 'get',
    params
  })
}
// 查看菜单详情
export async function menuDetail(params) {
  return request({
    url: apiDomain + '/base/admin/permission/detail',
    method: 'get',
    params
  })
}
// 创建或者更新菜单
export function createMenu(data) {
  return request({
    url: apiDomain + '/base/admin/permission/saveOrUpdate',
    method: 'post',
    data
  })
}
// 删除菜单系统
export async function deleteMenu(params) {
  return request({
    url: apiDomain + '/base/admin/permission/delete',
    method: 'get',
    params
  })
}
// 添加api或者页面
export function createPage(data) {
  return request({
    url: apiDomain + '/base/admin/menu/saveOrUpdate',
    method: 'post',
    data
  })
}
// 获取字典
export function getDictionary(params) {
  return request({
    url: apiDomain + '/dic/listByCode',
    method: 'get',
    params
  })
}
// 获取本地字典
export function getDictionarygetDictionary(params) {
  var dictionaryStr = window.localStorage.getItem('dictionary')
  if (dictionaryStr == '' || dictionaryStr == 'undefined' || dictionaryStr == null) {
    return getDictionary(params)
  } else {
    dictionaryStr = JSON.parse(dictionaryStr)
    return dictionaryStr[params]
  }
}
// 获取人员列表
export function personList(data) {
  return request({
    url: apiDomain + '/base/admin/user/list',
    method: 'post',
    data
  })
}
// 验证手机号唯一性
export function validatePhone(params) {
  return request({
    url: apiDomain + '/base/admin/user/valid/telephone',
    method: 'get',
    params
  })
}
// 重置密码
export function resetPwd(params) {
  return request({
    url: apiDomain + '/base/admin/user/resetPwd',
    method: 'get',
    params
  })
}
// 获取详情
export function userInfo(params) {
  return request({
    url: apiDomain + '/base/admin/user/detail',
    method: 'get',
    params
  })
}

// 开启关闭用户
export function open(params) {
  return request({
    url: apiDomain + '/base/admin/user/enable',
    method: 'get',
    params
  })
}
// 更新用户信息
export function update(data) {
  return request({
    url: apiDomain + '/base/admin/user/saveOrUpdate',
    method: 'post',
    data
  })
}
// 删除用户
export function deleteUser(params) {
  return request({
    url: apiDomain + '/base/admin/user/delete',
    method: 'get',
    params
  })
}
// 同步接口
export function synchroGetList(_url, _callback) {
  jq.ajax({
    type: 'GET',
    url: _url,
    async: false,
    beforeSend: function(request) {
      request.setRequestHeader('access_token', getStroage('token'))
    },
    success: function(res) {
      // const resData = JSON.parse(res)
      // _callback(resData)
      _callback(res)
    },
    error: function(e) {
      console.log('this error is in function ' + e)
      // window.location.href = ssoLoginAddress + 'http://' + window.document.location.host
    }
  })
}

// 获取部门列表
export function getAllDepartList(_callback) {
  synchroGetList(apiDomain + '/base/admin/office/list', _callback)
}
// 获取公司部门
export function getDepartList(params) {
  return request({
    url: apiDomain + '/base/admin/office/list',
    method: 'get',
    params
  })
}
// 新增或者修改部门
export function updateDepart(data) {
  return request({
    url: apiDomain + '/base/admin/office/saveOrUpdate',
    method: 'post',
    data
  })
}

// 获取部门信息
export function getDepartInfo(params) {
  return request({
    url: apiDomain + '/base/admin/office/detail',
    method: 'get',
    params
  })
}
// 删除部门信息
export function deleteDepart(params) {
  return request({
    url: apiDomain + '/base/admin/office/delete',
    method: 'get',
    params
  })
}

// 获取参数配置列表
export function paramList(params) {
  return request({
    url: apiDomain + '/base/admin/param/list',
    method: 'get',
    params
  })
}
// 获取参数配置详情
export function paramDetail(params) {
  return request({
    url: apiDomain + '/base/admin/param/detail',
    method: 'get',
    params
  })
}
// 删除参数列表详情
export function deleteParam(params) {
  return request({
    url: apiDomain + '/base/admin/param/delete',
    method: 'get',
    params
  })
}
// 添加或者编辑参数
export function addParam(data) {
  return request({
    url: apiDomain + '/base/admin/param/saveOrUpdate',
    method: 'post',
    data
  })
}
// 获取字典配置列表
export function dictList(params) {
  return request({
    url: apiDomain + '/base/admin/dic/list',
    method: 'get',
    params
  })
}
// 字典详情
export function dicDetail(params) {
  return request({
    url: apiDomain + '/base/admin/dic/detail',
    method: 'get',
    params
  })
}
// 字典新增或者修改
export function addDic(data) {
  return request({
    url: apiDomain + '/base/admin/dic/saveOrUpdate',
    method: 'post',
    data
  })
}
// 删除字典
export function deleteDic(params) {
  return request({
    url: apiDomain + '/base/admin/dic/delete',
    method: 'post',
    params
  })
}
// 移除成员

export function removeRole(params) {
  return request({
    url: apiDomain + '/base/admin/office/remove/user',
    method: 'get',
    params
  })
}
// 添加成员

export function addUser(params) {
  return request({
    url: apiDomain + '/base/admin/office/add/user',
    method: 'get',
    params
  })
}
// 未分配部门的成员
export function undistributedUser(data) {
  return request({
    url: apiDomain + '/base/admin/user/filterList',
    method: 'post',
    data
  })
}
// 检验字典key的唯一性
export function validateDicKey(params) {
  return request({
    url: apiDomain + '/base/admin/dic/vaildKey',
    method: 'get',
    params
  })
}
// 检验字典key的唯一性
export function validateParamKey(params) {
  return request({
    url: apiDomain + '/base/admin/param/vaildKey',
    method: 'get',
    params
  })
}
// 获取字典字典项
export function getDicKey(params) {
  return request({
    url: apiDomain + '/base/admin/dic/ListByKey',
    method: 'get',
    params
  })
}

// 退出
export function quit(params) {
  return request({
    url: apiDomain + '/base/admin/enter/logout',
    method: 'get',
    params
  })
}
// 是否为主管
export function isLeader(params) {
  return request({
    url: apiDomain + '/base/admin/office/update/officeAdminFlag',
    method: 'get',
    params
  })
}

